import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translationEN.json';
import translationFI from './locales/fi/translationFI.json';
import translationSVE from './locales/sve/translationSVE.json';

const resources = {
  en: {
    translation: translationEN
  },
  fi: {
    translation: translationFI
  },
  sve: {
    translation: translationSVE
  }
};
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',

    keySeparator: false,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
